import { Card, CardContent } from "src/components/ui/card";
import { useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";

interface NavigationCardProps {
  imageSrc: string;
  label: string;
  href: string;
}

export const NavigationCard = ({
  imageSrc,
  label,
  href,
}: NavigationCardProps) => {
  const navigate = useNavigate();
  return (
    <Card className="relative w-[200px] border-0 shadow-lg hover:shadow-2xl md:h-[260px] md:w-[220px] cursor-pointer" onClick={() => navigate(href)}>
      <CardContent className="flex h-full w-full flex-col items-center justify-center gap-6 p-2">
        <img
          src={imageSrc}
          alt=""
          className="size-44 rounded-lg object-contain"
        />
        <div className="text-center text-primary font-semibold md:text-xl flex gap-2 items-center">
          <span>{label}</span>
          <ArrowRight size={32}  className="text-primary"/>
        </div>
      </CardContent>
    </Card>
  );
};
